import Vue from "vue";
import Vuex from "vuex";
import { Message, MessageBox } from "element-ui";
import { verification, numFulter, modelFulter } from "@/utils/socketFulter";
Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    /* socked statr */

    websock: null,
    readyState: "连接失败",
    skreadyState: false,
    clearFlag: false,
    resoveMsg: "",
    onsocket: {
      data: "16DF040201340030",
      code: 3,
    },
    offsocket: {
      data: "16DF040201350031",
      code: 3,
    },
    /* socked end */
    isCollapse: false,
    sideWidth: "200px",
    userInfo: {},
    current_path: {
      name: "首页",
      path: "/home",
      menuIcon: "home",
    },
    menulist: [
      {
        id: "0",
        menuIcon: "home",
        menuName: "首页",
        menuPath: "/home",
        menuType: "home9999999",
        parentId: "home9999999",
      },
    ],
  },

  actions: {
    WEBSOCKET_INIT(context) {
      context.commit("createSocket");
    },
    WEBSOCKET_MSG(context, p) {
      context.commit("send", p);
    },
    WEBSOCKET_ERROR(context) {
      context.commit("ERROR_CLOEAR");
    },
  },
  mutations: {
    /* websocket  start*/

    WEBSOCKET_CLEAR(state) {
      let { websock } = state;
      if (websock && websock.readyState === websock.OPEN) {
        state.websock.send(
          JSON.stringify({
            data: "16DF040201350031",
            code: 3,
          })
        );
        state.websock.send(
          JSON.stringify({
            data: "16DF04020190008C",
            code: 1,
          })
        );
      }
    },

    WEBSOCKET_RFIDOFF(state) {
      let { websock } = state;
      if (websock && websock.readyState === websock.OPEN) {
        websock.send(
          JSON.stringify({
            data: "16DF040201350031",
            code: 3,
          })
        );
      }
    },
    WEBSOCKET_RFIDON(state) {
      if (state.websock) {
        if (!state.skreadyState && state.websock.readyState == 1) {
          state.websock.send(
            JSON.stringify({
              data: "16DF040201340030",
              code: 3,
            })
          );
        }
      }
    },
    send(state, data) {
      let { websock } = state;
      if (websock && websock.readyState === websock.OPEN) {
        state.websock.send(JSON.stringify(data));
      }
    },
    createSocket(state, p) {
      // debugger
      if (!state.websock) {
        state.websock = new WebSocket(
          `ws://127.0.0.1:${
            window.localStorage.getItem("wsport")
              ? window.localStorage.getItem("wsport")
              : 13767
          }/Chat`
        );

        state.websock.onmessage = function(e) {
          if (!state.clearFlag) {
            state.clearFlag = true;
            state.websock.send(
              JSON.stringify({
                data: "16DF04020190008C",
                code: 1,
              })
            );
          }

          state.readyState = "已连接";

          let res = JSON.parse(e.data);
          if (res.code == 2) {
            if (state.readyState !== "已连接") {
              state.readyState = "已连接";
            }
            if (res.data.substring(0, 4) !== "16DF") {
              let num = Math.floor(Math.random() * (9999 - 1000)) + 1000;
              state.resoveMsg = num + "&&" + res.data;
            } else {
              if (res.data == "16DF040102350031") {
                state.skreadyState = false;
              } else if (res.data == "16DF040102340030") {
                state.skreadyState = true;
              }
            }
          } else if (res.code == 3 && !res.data.isConnect) {
            state.readyState = "无扫描器";
          } else if (res.code == 3 && res.data.isConnect) {
            state.readyState = "已连接";

            state.websock.send(
              JSON.stringify({
                data:
                  "16DF04020192" +
                  numFulter(window.localStorage.getItem("zichan_power")) +
                  "00" +
                  verification(
                    "16DF04010292" +
                      numFulter(window.localStorage.getItem("zichan_power")) +
                      "00"
                  ),
                code: 3,
              })
            );
            state.websock.send(JSON.stringify(state.onsocket));
          } else if (res.code == 1) {
            if (res.msg == "设备未连接") {
              state.readyState = "无扫描器";
            } else {
              Message({
                showClose: true,
                message: res.msg,
                type: "error",
              });
            }
          }
        };
        state.websock.onopen = function(e) {
          state.websock.send(
            JSON.stringify({
              data: "16DF040201350031",
              code: 3,
            })
          );
          if (e.currentTarget.readyState == 1) {
            state.readyState = "已连接";
          } else {
            state.readyState = "正在连接";
          }
        };

        state.websock.onerror = function(e) {
          state.readyState = "连接断开";
        };
        state.websock.onclose = function(e) {
          state.skreadyState = false;

          state.readyState = "连接断开";
        };
      }
    },

    /* websocket end  */
    // 用户资料
    userInfo_ser(state, p) {
      state.userInfo = p;
    },
    // 菜单设置
    menulist_set(state, p) {
      if (p.length) {
        state.menulist = [...state.menulist, ...p];
      } else {
        state.menulist = [
          {
            id: "0",
            menuIcon: "home",
            menuName: "首页",
            menuPath: "/home",
            menuType: "home9999999",
            parentId: "home9999999",
          },
        ];
      }
    },
    // 动态菜单切换
    current_path(state, p) {
      state.current_path = p;
    },
    // 菜单是否折叠
    aside_collapse_flag(state) {
      state.sideWidth == "200px"
        ? (state.sideWidth = "80px")
        : (state.sideWidth = "200px");

      state.isCollapse = !state.isCollapse;
    },
  },
});
export default store;
